export const URL_PARAMETER_TYPES = [
  { value: "utm_source", label: "UTM_Source" },
  { value: "utm_medium", label: "UTM_Medium" },
  { value: "utm_campaign", label: "UTM_Campaign" },
  { value: "utm_term", label: "UTM_Term" },
  { value: "utm_content", label: "UTM_Content" },
  { value: "other", label: "Other" },
] as const;
